import { RichTextBlock } from 'prismic-reactjs';

export type Item = {
  title: Array<RichTextBlock>;
  description: Array<RichTextBlock>;
  image: RichTextBlock;
  position: 'BOTTOM' | 'TOP';
};

export enum StageKey {
  TOP = 'top',
  BOTTOM = 'bottom',
}
